import React from "react";
import { useNavigate } from "react-router-dom";
const token = localStorage.getItem("token");

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <div
      style={{ textAlign: "center", marginTop: "50px" }}
      className="flex flex-col gap-y-2 justify-center items-center"
    >
      <h1 className="text-red-600 text-4xl font-bold">404 - Page Not Found</h1>
      <p>The page you are looking for does not exist.</p>
      <button
        onClick={() => {
          if (token) navigate("/admin/dashboard");
          else navigate("/auth");
        }}
        className="px-3 py-2 bg-main hover:bg-mainHover text-white transition-all ease-in-out duration-500 rounded-lg"
      >
        Go to Home
      </button>
    </div>
  );
};

export default NotFound;
